function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 5 4 L 5 5 L 5 6 L 5 6.34375 L 5.21875 6.625 L 13 16.34375 L 13 26 L 13 28 L 14.59375 26.8125 L 18.59375 23.8125 L 19 23.5 L 19 23 L 19 16.34375 L 26.78125 6.625 L 27 6.34375 L 27 6 L 27 5 L 27 4 L 26 4 L 6 4 L 5 4 z M 7.28125 6 L 24.71875 6 L 17.53125 15 L 14.46875 15 L 7.28125 6 z M 15 17 L 17 17 L 17 22.5 L 15 24 L 15 17 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/filter.dd6bdcca.svg";
export { SvgComponent as ReactComponent };